import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-2 col-3 py-0 middle-label center" }
const _hoisted_3 = { class: "col-9 pl-0 m-0 py-0 center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode(" Acepto "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/terminos-y-condiciones",
    target: "_blank"
  }, "T&C"),
  /*#__PURE__*/_createTextVNode(" | "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/aviso-de-privacidad",
    target: "_blank"
  }, "Aviso de privacidad"),
  /*#__PURE__*/_createTextVNode(" | "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/aviso-de-privacidad#advertising",
    target: "_blank"
  }, "Suscripción y recepción de promociones"),
  /*#__PURE__*/_createTextVNode(" del servicio. ")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_InputSwitch, {
        onChange: _ctx.setValues,
        modelValue: _ctx.v$.name.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event))
      }, null, 8, ["onChange", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["switch-label", [
            _ctx.isRequired && !_ctx.v$.name.$model && _ctx.isSubmitted
              ? 'p-error'
              : _ctx.v$.name.$model
              ? 'p-success'
              : '',
          ]]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => {
            _ctx.v$.name.$model = !_ctx.v$.name.$model;
            _ctx.setValues();
          })
      }, [
        (_ctx.answerKey === 'termsAndConditions')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("label", null, _toDisplayString(_ctx.label), 1)
            ]))
      ], 2)
    ])
  ]))
}